var _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoctorIconBw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.50011 2.5C2.41677 4 3.00011 7 6.00012 7C9.00012 7 9.58347 4 9.50012 2.5",
    stroke: "#A5A6BB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.5C2 9.5 2.75 10.5 4 10.5C5.25 10.5 6 9.5 6 8.5V7",
    stroke: "#A5A6BB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 2.5,
    r: 1,
    stroke: "#A5A6BB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 2.5C9.5 3.05229 9.0523 3.5 8.5 3.5C7.9477 3.5 7.5 3.05229 7.5 2.5C7.5 1.94771 7.9477 1.5 8.5 1.5C9.0523 1.5 9.5 1.94771 9.5 2.5Z",
    stroke: "#A5A6BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorIconBw);
export default __webpack_public_path__ + "static/media/doctor-icon-bw.03346ed8c8afc917f612b741e1ea0387.svg";
export { ForwardRef as ReactComponent };